import { useQuery, useQueryClient } from "react-query";
import { useParams } from "react-router-dom";
import { getInvoiceDetails } from "../../../../services/inventory";
import { useGetSuppliers } from "../../../../hooks/api/queries";
import { useState } from "react";

export const useInvoiceDetails = () => {
  const params = useParams();
  const invoice_id = params.id;
  const [isInvoice, setIsInvoice] = useState(null);
  const queryClient = useQueryClient();

  const { data: suppliers, isLoading: isFetchingSupplier } = useGetSuppliers();

  const {
    isLoading: isFetchingInvoiceDetails,
    data: invoiceDetails,
    refetch: refetchInvoiceDetails,
  } = useQuery(["invoiceDetails", invoice_id], () =>
    getInvoiceDetails(invoice_id).then((res) => res.data?.data),
  );

  return {
    isFetchingInvoiceDetails,
    isFetchingSupplier,
    suppliers,
    invoiceDetails,
    isInvoice,
    setIsInvoice,
    queryClient,
    refetchInvoiceDetails,
  };
};
